export const caseStudiesData = [
  {
    id: 1,
    title: "Web3 Wallet",
    description: [
      "This Web3 Wallet is a non-custodial, user-centric digital asset management solution designed to simplify how users interact with blockchain ecosystems. It enables individuals to securely store, manage, and transact with cryptocurrencies, NFTs, and other digital assets while maintaining full ownership and control.",
      "With increasing complexity in Web3 onboarding, this wallet bridges the gap between usability and decentralization, making it suitable for both beginners and advanced users",
    ],
    image: "assets/img/case-studies/tg-wallet/one.png",
    titleicon: "wallet",
    tags: ["Free Customers", "Web3 Prediction Markets"],
    category: "Web3 Wallet",
    chains: ["Polygon"],
    icons: [""],
    solution: {
      intro:
        "The wallet was built with a focus on accessibility, security, and seamless ecosystem integration:",

      points: [
        {
          title: "User-Friendly Interface",
          desc: "Simplified onboarding with intuitive UI/UX for mass adoption",
        },
        {
          title: "Non-Custodial Security",
          desc: "Private keys fully controlled by users, ensuring asset ownership",
        },
        {
          title: "Multi-Asset Support",
          desc: "Manage tokens, NFTs, and ecosystem assets in a single wallet",
        },
        {
          title: "Chain-Agnostic Experience",
          desc: "Smooth interaction across multiple blockchain networks",
        },
        {
          title: "Ecosystem Integration",
          desc: "Direct access to dApps, DeFi platforms, and services",
        },
      ],

      summary:
        "A secure and scalable Web3 wallet solution that enhances user experience while maintaining decentralization, enabling seamless participation in the blockchain ecosystem.",
    },
    projectimage: [
      "../assets/img/case-studies/tg-wallet/one.png",
      "../assets/img/case-studies/tg-wallet/two.png",
      "../assets/img/case-studies/tg-wallet/three.png",
      // "../assets/img/case-studies/tg-wallet/four.png",
    ],
  },
  {
    id: 2,
    title: "NFT Marketplace",
    description:
      "The NFT Marketplace is a decentralized digital asset platform that empowers creators and users to mint, trade, and manage NFTs efficiently. Designed to support emerging use cases like gaming, metaverse assets, and digital ownership, the platform ensures transparency, security, and accessibility.",
    image: "assets/img/case-studies/nft/two.png",
    titleicon: "nft",
    tags: ["Best-in-Class Apps", "Decentralized Exchanges (DEXs)"],
    category: "NFT",
    chains: ["Ethereum", "Arbitrum", "Optimism"],
    icons: [
      "https://cryptologos.cc/logos/ethereum-eth-logo.png",
      "https://cryptologos.cc/logos/arbitrum-arb-logo.png",
      "https://cryptologos.cc/logos/optimism-op-logo.png",
    ],
    solution: {
      intro: "The platform delivers a comprehensive NFT ecosystem",

      points: [
        {
          title: "Low-Cost Transactions",
          desc: "Optimized infrastructure for reduced gas fees",
        },
        {
          title: "Creator-Friendly Tools",
          desc: "Easy minting, listing, and royalty management",
        },
        {
          title: "Utility-Based NFTs",
          desc: "Integration with gaming, rewards, and metaverse ecosystems",
        },
        {
          title: "Secure Ownership",
          desc: "Blockchain-backed authenticity and ownership verification",
        },
        {
          title: "Wallet Integration",
          desc: "Seamless connection with Web3 wallets for transactions",
        },
      ],

      summary:
        "A scalable NFT ecosystem enabling creators and users to unlock the full potential of digital ownership with cost-efficient and secure transactions",
    },
    projectimage: [
      "../assets/img/case-studies/nft/one.png",
      "../assets/img/case-studies/nft/two.png",
      "../assets/img/case-studies/nft/three.png",
      "../assets/img/case-studies/nft/four.png",
      "../assets/img/case-studies/nft/five.png",
      // "../assets/img/case-studies/nft/six.png",
      // "../assets/img/case-studies/nft/seven.png",
    ],
  },
  {
    id: 3,
    title: "Trading Bot on TON",
    description:
      "This project involves an advanced automated trading platform built on the TON blockchain, designed to simplify and optimize crypto trading through intelligent automation. It allows users to execute strategies without constant monitoring, reducing manual effort and emotional decision-making.",
    image: "assets/img/case-studies/bot/one.png",
    titleicon: "bot",
    tags: ["Ecosystem Partners", "Decentralized Exchanges (DEXs)"],
    category: "Trading Bot",
    chains: ["Ethereum"],
    icons: ["https://cryptologos.cc/logos/ethereum-eth-logo.png"],
    solution: {
      intro: "The platform integrates powerful automation and analytics tools",

      points: [
        {
          title: "Custom Trading Bots",
          desc: "Tailored strategies based on user-defined risk profiles",
        },
        {
          title: "Multi-Exchange Integration",
          desc: "Access to broader liquidity and trading opportunities",
        },
        {
          title: "Algorithmic Trading",
          desc: "High-speed execution using pre-defined strategies",
        },
        {
          title: "Real-Time Analytics",
          desc: "Market insights powered by advanced data analysis",
        },
        {
          title: "Automated Strategies",
          desc: "Arbitrage, trend-following, and copy trading functionalities",
        },
      ],

      summary:
        "An intelligent trading ecosystem that enables users to maximize efficiency, reduce risks, and capitalize on market opportunities through automation",
    },
    projectimage: [
      "../assets/img/case-studies/bot/one.png",
      "../assets/img/case-studies/bot/two.png",
      "../assets/img/case-studies/bot/three.png",
      "../assets/img/case-studies/bot/four.png",
      "../assets/img/case-studies/bot/five.png",
      "../assets/img/case-studies/bot/six.png",
      "../assets/img/case-studies/bot/seven.png",
    ],
  },
  {
    id: 4,
    title: "Tap Tap Game (DApp) ",
    description: [
      "A blockchain-based gamified application designed to drive mass user engagement through simple tap-to-earn mechanics. The platform combines gaming with token incentives, enabling rapid user acquisition and retention within a Web3 ecosystem.",
      // "The platform focuses on eliminating traditional inefficiencies by leveraging decentralized infrastructure",
    ],
    image: "assets/img/case-studies/dapp/one.png",
    titleicon: "dapp",
    tags: ["Decentralized Exchanges (DEXs)"],
    category: "DApp",
    chains: ["Ethereum"],
    icons: ["https://cryptologos.cc/logos/ethereum-eth-logo.png"],
    solution: {
      intro:
        "A gamified Web3 architecture designed to drive viral user growth, engagement, and automated reward distribution:",

      points: [
        {
          title: "Tap-to-Earn Reward System",
          desc: "Users earn tokens through simple tapping actions, powered by smart contracts to ensure transparent and automated reward distribution.",
        },
        {
          title: "Wallet Integration",
          desc: "Seamless Web3 wallet connection allows users to join instantly without complex onboarding processes.",
        },
        {
          title: "Referral & Viral Growth Engine",
          desc: "A built-in referral system incentivizes users to invite others, driving exponential user acquisition.",
        },
        {
          title: "Gamification Features",
          desc: "Daily missions, leaderboards, and reward tiers keep users engaged and increase retention.",
        },
        {
          title: "Scalable Infrastructure",
          desc: "Backend designed to handle high concurrent users during peak traffic and viral growth phases.",
        },
      ],

      summary:
        "A high-engagement Web3 gaming solution that accelerates community growth, token adoption, and user retention through gamification.",
    },
    projectimage: [
      "../assets/img/case-studies/dapp/one.png",
      "../assets/img/case-studies/dapp/two.png",
      "../assets/img/case-studies/dapp/three.png",
      "../assets/img/case-studies/dapp/four.png",
    ],
  },
  {
    id: 5,
    title: "DPoS Blockchain (Cosmos SDK with MultiVM)",
    description:
      "Developed a custom Delegated Proof of Stake (DPoS) blockchain using Cosmos SDK with MultiVM support, enabling high scalability, interoperability, and multi-environment execution.",
    image: "assets/img/case-studies/GTBS_NFT/one.png",
    titleicon: "carbon",
    tags: ["Cosmos SDK with MultiVM"],
    category: "Blockchain",
    chains: ["Solana"],
    icons: ["https://cryptologos.cc/logos/solana-sol-logo.png"],
    solution: {
      intro:
        "A scalable and interoperable blockchain infrastructure enabling high performance, multi-VM compatibility, and decentralized governance.",

      points: [
        {
          title: "Custom Blockchain Development (Cosmos SDK)",
          desc: "Built a modular blockchain using Cosmos SDK for flexibility, scalability, and ecosystem expansion.",
        },
        {
          title: "MultiVM Support",
          desc: "Enabled compatibility with multiple virtual machines (EVM and others), allowing diverse smart contract execution.",
        },
        {
          title: "DPoS Consensus Mechanism",
          desc: "Implemented Delegated Proof of Stake to ensure faster transactions and efficient validator participation.",
        },
        {
          title: "Cross-Chain Interoperability",
          desc: "Integrated IBC protocol to enable seamless communication with other blockchain networks.",
        },
        {
          title: "Governance Module",
          desc: "On-chain governance allows token holders to vote on proposals and upgrades.",
        },
      ],

      summary:
        "A scalable and customizable blockchain infrastructure designed for enterprise-grade performance, interoperability, and multi-chain ecosystem expansion.",
    },
    projectimage: [
      "../assets/img/case-studies/GTBS_NFT/one.png",
      "../assets/img/case-studies/GTBS_NFT/two.png",
      "../assets/img/case-studies/GTBS_NFT/three.png",
      "../assets/img/case-studies/GTBS_NFT/four.png",
      "../assets/img/case-studies/GTBS_NFT/five.png",

      // "../assets/img/case-studies/dollar-pay/one.png",
      // "../assets/img/case-studies/dollar-pay/two.png",
      // "../assets/img/case-studies/dollar-pay/three.png",
      // "../assets/img/case-studies/dollar-pay/four.png",
      // "../assets/img/case-studies/dollar-pay/five.png",
      // "../assets/img/case-studies/dollar-pay/six.png",
      // "../assets/img/case-studies/dollar-pay/seven.png",
    ],
  },

  {
    id: 6,
    title: "DeFi with Crowdfunding",
    description:
      "A decentralized platform combining crowdfunding with DeFi utilities, enabling users to invest, earn rewards, and participate in funding opportunities transparently.",
    image: "assets/img/case-studies/defi/one.png",
    titleicon: "defi",
    tags: ["Enterprise Customers"],
    category: "DeFi",
    chains: ["Arbitrum"],
    icons: ["https://cryptologos.cc/logos/arbitrum-arb-logo.png"],
    solution: {
      intro:
        "A decentralized fundraising ecosystem combining transparent crowdfunding with automated financial utilities and investor rewards.",

      points: [
        {
          title: "Decentralized Crowdfunding Engine",
          desc: "Smart contracts manage fund collection and allocation without intermediaries.",
        },
        {
          title: "Tokenized Investment Model",
          desc: "Investors receive tokens representing their participation, enabling liquidity and tracking.",
        },
        {
          title: "Automated Reward Distribution",
          desc: "Earnings and incentives are distributed automatically based on predefined logic.",
        },
        {
          title: "Integrated DeFi Utilities",
          desc: "Staking and yield farming options allow users to maximize returns on investments.",
        },
        {
          title: "Transparent On-Chain Records",
          desc: "All transactions are recorded on blockchain for complete visibility and trust.",
        },
      ],

      summary:
        "A trustless fundraising ecosystem that enhances transparency, investor participation, and automated financial flows.",
    },
    projectimage: [
      "../assets/img/case-studies/defi/one.png",
      "../assets/img/case-studies/defi/two.png",
      "../assets/img/case-studies/defi/three.png",
      "../assets/img/case-studies/defi/four.png",
      "../assets/img/case-studies/defi/five.png",
      "../assets/img/case-studies/defi/six.png",
      "../assets/img/case-studies/defi/seven.png",
    ],
  },
  {
    id: 7,
    title: "Decentralized Exchange (DEX)",
    description:
      "Built a non-custodial decentralized exchange allowing users to trade tokens directly from their wallets without intermediaries.",
    image: "assets/img/case-studies/dex/one.png",
    titleicon: "carbon",
    tags: ["DEXs"],
    category: "dex",
    chains: ["Ethereum"],
    icons: ["https://cryptologos.cc/logos/ethereum-eth-logo.png"],
    solution: {
      intro:
        "A non-custodial trading platform enabling secure, transparent, and seamless token swaps through liquidity-driven protocols.",

      points: [
        {
          title: "AMM-Based Token Swapping",
          desc: "Users can trade tokens directly via liquidity pools without relying on order books.",
        },
        {
          title: "Liquidity Pool Management",
          desc: "Users can add/remove liquidity and earn rewards based on their contribution.",
        },
        {
          title: "Wallet-Based Trading",
          desc: "Non-custodial approach ensures users maintain full control over their assets",
        },
        {
          title: "Yield Farming Integration",
          desc: "Liquidity providers are incentivized with additional token rewards.",
        },
        {
          title: "Real-Time Data & Analytics",
          desc: "Users can track token performance, liquidity, and trading activity in real-time.",
        },
      ],

      summary:
        "A secure and transparent trading platform enabling trustless transactions and community-driven liquidity growth.",
    },
    projectimage: [
      "../assets/img/case-studies/dex/one.png",
      "../assets/img/case-studies/dex/two.png",
      "../assets/img/case-studies/dex/three.png",
      "../assets/img/case-studies/dex/four.png",
      "../assets/img/case-studies/dex/five.png",
      "../assets/img/case-studies/dex/six.png",
      "../assets/img/case-studies/dex/seven.png",
    ],
  },
  {
    id: 8,
    title: "Staking DApp",
    description:
      "Developed a decentralized staking platform enabling users to lock their tokens and earn rewards through predefined smart contract mechanisms.",
    image: "assets/img/case-studies/staking/one.png",
    titleicon: "staking",
    tags: ["Best-in-Class Apps"],
    category: "Staking",
    chains: ["Ethereum", "Avalanche"],
    icons: [
      "https://cryptologos.cc/logos/ethereum-eth-logo.png",
      "https://cryptologos.cc/logos/avalanche-avax-logo.png",
    ],
    solution: {
      intro:
        "A smart contract-powered staking system designed to incentivize token holding and generate passive income for users.",

      points: [
        {
          title: "Flexible & Fixed Staking Models",
          desc: "Users can choose between short-term flexible staking or long-term fixed returns.",
        },
        {
          title: "Automated Reward Mechanism",
          desc: "Smart contracts calculate and distribute rewards without manual intervention.",
        },
        {
          title: "APY Configuration System",
          desc: "Admin can define and adjust reward rates based on tokenomics.",
        },
        {
          title: "User Dashboard",
          desc: "Clear interface for tracking staked assets, rewards, and lock-in periods.",
        },
        {
          title: "Secure Smart Contracts",
          desc: "Ensures safe locking and withdrawal of user funds.",
        },
      ],

      summary:
        "A powerful token utility system that encourages long-term holding, reduces market volatility, and strengthens community engagement.",
    },
    projectimage: [
      "../assets/img/case-studies/staking/one.png",
      "../assets/img/case-studies/staking/two.png",
      "../assets/img/case-studies/staking/three.png",
      "../assets/img/case-studies/staking/four.png",
      "../assets/img/case-studies/staking/five.png",
      "../assets/img/case-studies/staking/six.png",
      "../assets/img/case-studies/staking/seven.png",
    ],
  },
  {
    id: 9,
    title: "Centralized Exchange (Spot, P2P, F&O)",
    description:
      "A full-scale centralized crypto exchange offering Spot trading, Peer-to-Peer (P2P), and Futures & Options (F&O) trading for a complete trading experience.",
    image: "assets/img/case-studies/exchange/dex--one.png",
    titleicon: "p2p",
    tags: ["Best-in-Class Apps"],
    category: "Centralized Exchange",
    chains: ["Ethereum", "Avalanche"],
    icons: [
      "https://cryptologos.cc/logos/ethereum-eth-logo.png",
      "https://cryptologos.cc/logos/avalanche-avax-logo.png",
    ],
    solution: {
      intro:
        "A comprehensive trading ecosystem offering high-speed execution, secure transactions, and multiple trading options for all user levels.",

      points: [
        {
          title: "High-Speed Trading Engine",
          desc: "Supports spot and derivatives trading with real-time order execution.",
        },
        {
          title: "P2P Trading Module",
          desc: "Allows users to trade directly with each other using escrow-based protection.",
        },
        {
          title: "Futures & Options Trading",
          desc: "Advanced trading features for experienced users with leverage and hedging tools.",
        },
        {
          title: "Secure Wallet Infrastructure",
          desc: "Hot and cold wallet systems ensure safety of user funds.",
        },
        {
          title: "KYC & Compliance System",
          desc: "User verification and risk monitoring for regulatory readiness.",
        },
        {
          title: "Admin Control Panel",
          desc: "Full backend control for managing users, transactions, and liquidity.",
        },
      ],

      summary:
        "A comprehensive trading ecosystem designed for high liquidity, secure transactions, and multi-revenue stream generation.",
    },
    projectimage: [
      "../assets/img/case-studies/exchange/dex--one.png",
      "../assets/img/case-studies/exchange/dex--two.png",
      "../assets/img/case-studies/exchange/dex--three.png",
      "../assets/img/case-studies/exchange/dex--four.png",
      "../assets/img/case-studies/exchange/dex--five.png",
      "../assets/img/case-studies/exchange/dex--six.png",
      "../assets/img/case-studies/exchange/dex-one.png",
      "../assets/img/case-studies/exchange/dex-two.png",
      "../assets/img/case-studies/exchange/dex-three.png",
      "../assets/img/case-studies/exchange/dex-four.png",
      "../assets/img/case-studies/exchange/dex-five.png",
      "../assets/img/case-studies/exchange/dex-six.png",
      "../assets/img/case-studies/exchange/dex-seven.png",
    ],
  },
  {
    id: 10,
    title: "Web3 Event Platform",
    description:
      "A blockchain-powered event platform designed to manage and enhance Web3 events, ticketing, and community engagement.",
    image: "assets/img/case-studies/event/event-one.png",
    titleicon: "staking",
    tags: ["Best-in-Class Apps"],
    category: "Web3",
    chains: ["Ethereum", "Avalanche"],
    icons: [
      "https://cryptologos.cc/logos/ethereum-eth-logo.png",
      "https://cryptologos.cc/logos/avalanche-avax-logo.png",
    ],
    solution: {
      intro:
        "A blockchain-powered event management system ensuring secure ticketing, transparent access, and enhanced community engagement.",

      points: [
        {
          title: "NFT-Based Ticketing System",
          desc: "Tickets are minted as NFTs, ensuring authenticity and preventing duplication.",
        },
        {
          title: "Wallet-Based Access",
          desc: "Users access events using their wallets, eliminating traditional login systems.",
        },
        {
          title: "Event Management Dashboard",
          desc: "Organizers can create, manage, and track events easily.",
        },
        {
          title: "On-Chain Verification",
          desc: "All tickets and transactions are verifiable on blockchain for transparency.",
        },
        {
          title: "Community Engagement Tools",
          desc: "Features like announcements and rewards enhance attendee interaction.",
        },
      ],

      summary:
        "A modern event solution leveraging blockchain to deliver secure ticketing, transparent access control, and enhanced user experience.",
    },
    projectimage: [
      "../assets/img/case-studies/event/event-one.png",
      "../assets/img/case-studies/event/event-two.png",
      "../assets/img/case-studies/event/event-three.png",
      "../assets/img/case-studies/event/event-four.png",
      "../assets/img/case-studies/event/event-five.png",
      "../assets/img/case-studies/event/event-six.png",
    ],
  },
  // new
  {
    id: 11,
    title: "Cloud Storage Provider",
    description:
      "Developed a secure and scalable cloud storage platform designed to enable users and enterprises to store, manage, and access data efficiently. The solution focuses on reliability, data security, and seamless accessibility across devices.",
    image: "assets/img/case-studies/cloud/cloud-drive-one.png",
    titleicon: "staking",
    tags: ["Best-in-Class Apps"],
    category: "Cloud",
    // chains: ["Ethereum", "Avalanche"],
    icons: [
      "https://cryptologos.cc/logos/ethereum-eth-logo.png",
      "https://cryptologos.cc/logos/avalanche-avax-logo.png",
    ],
    solution: {
      intro:
        "A robust cloud infrastructure built to ensure secure storage, high availability, and seamless data management.",

      points: [
        {
          title: "Secure File Storage System",
          desc: "Enabled encrypted storage of files with role-based access control to ensure data privacy and protection.",
        },
        {
          title: "Scalable Cloud Architecture",
          desc: "Designed infrastructure capable of handling large volumes of data with high availability and minimal downtime.",
        },
        {
          title: "Multi-Device Accessibility",
          desc: "Users can access, upload, and manage files from web and mobile platforms seamlessly.",
        },
        {
          title: "Backup & Recovery Mechanism",
          desc: "Automated backup and disaster recovery systems ensure data safety and business continuity.",
        },
        {
          title: "User & Permission Management",
          desc: "Advanced access control for teams and organizations to manage data sharing securely.",
        },
      ],

      summary:
        "A reliable cloud storage solution that enhances data security, accessibility, and scalability for businesses and individual users.",
    },
    projectimage: [
      "../assets/img/case-studies/cloud/cloud-drive-one.png",
      "../assets/img/case-studies/cloud/cloud-drive-two.png",
      "../assets/img/case-studies/cloud/cloud-drive-three.png",
      "../assets/img/case-studies/cloud/cloud-drive-four.png",
      "../assets/img/case-studies/cloud/cloud-drive-five.png",
      "../assets/img/case-studies/cloud/cloud-drive-six.png",
      "../assets/img/case-studies/cloud/cloud-drive-seven.png",
    ],
  },
  {
    id: 12,
    title: "Hosting Services Provider",
    description:
      "Built a comprehensive hosting platform offering high-performance and reliable hosting services for websites, applications, and enterprise solutions. Designed to ensure uptime, speed, and scalability.  ",
    image: "assets/img/case-studies/cloud/cloud-host-one.png",
    titleicon: "staking",
    tags: ["Best-in-Class Apps"],
    category: "Hosting",
    // chains: ["Ethereum", "Avalanche"],
    icons: [
      "https://cryptologos.cc/logos/ethereum-eth-logo.png",
      "https://cryptologos.cc/logos/avalanche-avax-logo.png",
    ],
    solution: {
      intro:
        "A performance-driven hosting ecosystem designed to deliver speed, uptime, and seamless deployment for digital platforms.",

      points: [
        {
          title: "High-Performance Server Infrastructure",
          desc: "Optimized servers for fast loading times and consistent performance across applications.",
        },
        {
          title: "Multi-Tier Hosting Plans",
          desc: "Flexible hosting options including shared, VPS, and dedicated environments based on user requirements.",
        },
        {
          title: "Automated Deployment Tools",
          desc: "Simplified website and application deployment with one-click setup features.",
        },
        {
          title: "Monitoring & Uptime Management",
          desc: "Real-time monitoring tools to ensure maximum uptime and quick issue resolution",
        },
        {
          title: "Security & Firewall Integration",
          desc: "Advanced security layers including DDoS protection and firewall configurations.",
        },
      ],

      summary:
        "A scalable hosting solution that ensures high performance, reliability, and secure deployment for digital businesses.",
    },
    projectimage: [
      "../assets/img/case-studies/cloud/cloud-host-one.png",
      "../assets/img/case-studies/cloud/cloud-host-two.png",
      "../assets/img/case-studies/cloud/cloud-host-three.png",
      "../assets/img/case-studies/cloud/cloud-host-four.png",
      "../assets/img/case-studies/cloud/cloud-host-five.png",
      "../assets/img/case-studies/cloud/cloud-host-six.png",
      "../assets/img/case-studies/cloud/cloud-host-seven.png",
      "../assets/img/case-studies/cloud/cloud-host-eight.png",
    ],
  },
  {
    id: 13,
    title: "Mail Services Provider",
    description:
      "Developed a professional email hosting and communication platform tailored for businesses, enabling secure, reliable, and branded email communication.",
    image: "assets/img/case-studies/cloud/cloud-mail-one.png",
    titleicon: "staking",
    tags: ["Best-in-Class Apps"],
    category: "Mail",
    // chains: ["Ethereum", "Avalanche"],
    icons: [
      "https://cryptologos.cc/logos/ethereum-eth-logo.png",
      "https://cryptologos.cc/logos/avalanche-avax-logo.png",
    ],
    solution: {
      intro:
        "A secure and enterprise-ready email infrastructure designed for seamless communication and data protection.",

      points: [
        {
          title: "Custom Domain Email Hosting",
          desc: "Businesses can create and manage professional email addresses using their own domain.",
        },
        {
          title: "Advanced Security & Spam Protection",
          desc: "Integrated anti-spam filters and encryption to ensure safe communication",
        },
        {
          title: "High Deliverability System",
          desc: "Optimized infrastructure to improve email delivery rates and reduce spam issues.",
        },
        {
          title: "Cross-Platform Access",
          desc: "Accessible via web, mobile, and third-party email clients for flexibility.",
        },
        {
          title: "Admin Control Panel",
          desc: "Centralized dashboard for managing users, storage, and permissions.",
        },
      ],

      summary:
        "A secure and scalable email solution that enables professional communication, high deliverability, and enterprise-grade reliability.",
    },
    projectimage: [
      "../assets/img/case-studies/cloud/cloud-mail-one.png",
      "../assets/img/case-studies/cloud/cloud-mail-two.png",
      "../assets/img/case-studies/cloud/cloud-mail-three.png",
      "../assets/img/case-studies/cloud/cloud-mail-four.png",
      "../assets/img/case-studies/cloud/cloud-mail-five.png",
    ],
  },
];
